<template>
  <div
    class="container mx-auto sm:px-12 laptop:px-24"
    :class="{'laptop:mt-100px pt-10 md:pt-16': !compact}"
  >
    <!-- laptop:mx-24 md:mx-8         p-5 md:p-0-->
    <div class="sm:p-0" :class="{'p-5' : !noPadding}">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
// import LazyComponent from 'v-lazy-component/vue2'
export default defineNuxtComponent({
  name: 'Block1Col',
  // components: { LazyComponent },
  props: {
    compact: { type: Boolean, default: false },
    noPadding: { type: Boolean, default: false }
  }
})
</script>

<style scoped>

</style>
